import { render } from "./STDSDC02C01BopUser.vue?vue&type=template&id=1b395f47&scoped=true"
import script from "./STDSDC02C01BopUser.vue?vue&type=script&lang=js"
export * from "./STDSDC02C01BopUser.vue?vue&type=script&lang=js"

import "./STDSDC02C01BopUser.vue?vue&type=style&index=0&id=1b395f47&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b395f47"]])

export default __exports__